import { BaseService } from "./baseService";
import apiClient from "./apiClient";

class DocumentViewerService extends BaseService<any> {
  constructor() {
    super("/DocumentViewer");
  }

  getDocumentUrl(documentId: number): string {
    return `${this.url}/${documentId}`;
  }

  async getDocumentBlob(documentId: number): Promise<Blob> {
    const response = await apiClient.get(this.getDocumentUrl(documentId), {
      responseType: "blob",
    });
    return response as unknown as Blob;
  }
}

export const documentViewerService = new DocumentViewerService();
